var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-child masking",style:(_vm.getSize())},[_c('masked-text',{attrs:{"text":_vm.maskedText,"max-dimensions":_vm.boundingBox,"zoom-factor":_vm.zoomFactor}}),_c('div',{staticClass:"overlay-child masking-overlay",style:(_vm.getStyle())})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }